import React, { Component } from "react";
import SplitThePot from "./SplitThePot";
import PrizeOnlyDraw from "./PrizeOnlyDraw";
import ChaseTheAce from "./ChaseTheAce";
import classnames from 'classnames';

class Hero extends Component {
  handleCheckout = e => {
    e.preventDefault();
    window.location.href = "/select-tickets";
  };

  render() {
    const { settings, language, event } = this.props;
    const heroBoxClasnames = classnames('w-full', 'text-center', {'box-it': +settings.hero_box_highlighting === 1});

    return (
      <div className="video-main video-bg" style={{ backgroundColor: settings.hero_background_color }}>
        <div className="video cover align-center align-middle">
          {settings.hero_video && settings.hero_video !== "" ? (
            <video src={`${settings.hero_video}`} type="video/mp4" preload="true" className="opacity-75" loop muted autoPlay poster={`${settings.hero_video_jpeg !== "" ? settings.hero_video_jpeg : ""}`}>
            </video>
          ) : (
              settings.hero_image && settings.hero_image !== "" ? (
                <img
                  src={`${settings.hero_image}`}
                  alt=""
                  className="opacity-75"
                />
              ) : (
                  settings.hero_background_color && settings.hero_background_color !== "" ? (
                    <div style={{ backgroundColor: settings.hero_background_color }} />
                  ) : (
                      <div style={{ backgroundColor: "#FFF !important" }} />
                    )
                )
            )}
        </div>
        <div className="content" >
          <div className="main-hero py-6 absolute w-full max-w-full" style={{ color: settings.hero_text_color, zIndex: 1 }}>
            <div className="flex items-stretch flex-wrap md:flex-row w-full">
              <div className="w-full md:w-1/3 primarylogo">
                {settings.primary_left_logo !== "" ? (
                  <img src={settings.primary_left_logo} alt="" className="block p-6 mx-auto" />
                ) : <div className="block p-6 mx-auto"></div>}
              </div>
              <div className="w-full md:w-1/3">
                <div className="flex items-stretch flex-wrap h-full" style={{ color: settings.hero_text_color }}>
                  {event.id === 0 ? (
                    <div className="w-full  text-center ">
                      <div className="font-semibold text-xl">Events coming soon! Please check back later.</div>
                    </div>
                  ) : (
                      <div className={heroBoxClasnames}  >
                        {event.game.id === 1 && (
                          <SplitThePot
                            event={event}
                            settings={settings}
                          />
                        )}
                        {event.game.id === 2 && (
                          <PrizeOnlyDraw
                            event={event}
                            settings={settings}
                          />
                        )}
                        {event.game.id === 3 && (
                          <ChaseTheAce
                            event={event}
                            settings={settings}
                            language={language}
                          />
                        )}
                        {event.is_active && event.web_enabled && +event.shopify_enabled !== 1 && (
                          <span
                            className="cursor-pointer inline-block no-underline bg-accent hover:bg-accent-dark text-primary font-bold text-xl py-4 px-6 rounded mt-8 shadow-outline"
                          >
                            BUY NOW
                          </span>
                        )}
                      </div>
                    )}
                </div>
              </div>
              <div className="w-full md:w-1/3 primarylogo">
                {settings.web_countdown_text && settings.web_countdown_text !== "" && (
                  <div
                    className="font-semibold text-base text-center p-2"
                    dangerouslySetInnerHTML={{
                      __html: settings.web_countdown_text
                    }}
                  />
                )}
                {settings.hero_proceeds_text && settings.hero_proceeds_text !== "" && (
                  <div
                    className="font-semibold text-base text-center p-2"
                    dangerouslySetInnerHTML={{
                      __html: settings.hero_proceeds_text
                    }}
                  />
                )}
                {settings.webcharityurl !== "" ? (
                  <a href={settings.webcharityurl} target="_blank" rel="noopener noreferrer">
                    <img src={settings.primary_right_logo} alt={settings.hero_proceeds_text} className="block p-6 mx-auto " />
                  </a>
                ) : <img src={settings.primary_right_logo} alt={settings.hero_proceeds_text} className="block p-6 mx-auto" />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Hero;
